import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

console.log("i18n.js - locale: ", localStorage.getItem('locale'));
const savedLocale = localStorage.getItem('locale') || (navigator.language || navigator.userLanguage).split('-')[0];
// compilo il tag <html lang> per l'accessibilità
document.documentElement.setAttribute('lang', savedLocale); 

export default new VueI18n({
  locale: savedLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
